import Vue from 'vue'
import Vuex from 'vuex'
import attachCognitoModule from '@vuetify/vuex-cognito-module'
// import createPersistedState from 'vuex-persistedstate'

const UserPool = 'us-west-2_XZPdfCwcx'
const IdPool = 'us-west-2:89854e74-acf3-41a2-b83d-3b706eacdc61'
const WebClient = '3d5od6g77ms89a8mn0jeups50'
const App = 'scottsdalebeachfest'
const OrgKey = 'ORG-1538652c-efe1-437d-9779-81c61ba7048at'
Vue.use(Vuex)

const set = property => (store, payload) => (store[property] = payload)

const store = new Vuex.Store({
  plugins: [/*createPersistedState()*/],
  state: {
    url: (process.env.NODE_ENV === 'development') ? 'https://api.18panels.com/' : 'https://api.18panels.com/',
    dev: (process.env.NODE_ENV === 'development'),
    icons:{
      group:'mdi-account-group',
      trash:'mdi-trash-can-outline',
      ban:'mdi-circle-off-outline',
      undo:'mdi-undo-variant',
      close:'mdi-close',
      plus:'mdi-plus-thick',
      minus:'mdi-minus-thick',
      thumbsup:'mdi-thumb-up',
      thumbsdown:'mdi-thumb-down',
      error:'mdi-thumb-down',
      success:'mdi-thumb-up',
      folder:'mdi-folder',
      edit:'mdi-file-edit',
      contact:'mdi-contact-mail-outline',
      send:'mdi-email-send-outline',
      checkon:'mdi-checkbox-marked',
      checkoff:'mdi-checkbox-blank-outline',
      info:'mdi-information-outline',
      search:'mdi-shield-search',
      copy:'mdi-content-copy',
      warning:'mdi-map-marker-question-outline',
      question:'far fa-question-circle',
      user:'mdi-account-group-outline',
      sms: 'mdi-message-reply',
      email: 'mdi-email',
      voicemail:'mdi-voicemail',
      instagram: 'mdi-instagram',
      paypal: 'mdi-paypal',
      stripe: 'mdi-stripe-s',
      dashboard: 'mdi-apps',
      calendar: 'mdi-calendar',
      clock: 'mdi-clock',
      home: 'mdi-home'
    },
    stripeClient: (process.env.NODE_ENV === 'development') ? 'testkey' : 'livekey', //18panels codes
    productid: (process.env.NODE_ENV === 'development') ?  'staticproduct-test' : 'staticproduct-live',
    events:[],
    activeevent:undefined,
    email: '',
    username:'',
    confirmationcode:'',
    isLoading: false,
    isReady: false,
    loggedin:false,
    password: '',
    color1:'light-blue darken-4',
    color2:'light-blue',
    coloron:'blue',
    colorhex:'#01579B',
    snackbar: {},
    appdata:false,
    org:undefined,
    rules:{
      nameRules: v => { if(v) { return (v === v ) || 'Name' } else return true },
      emailRules: v => { if(v) { return /.+@.+\..+/.test(v) || 'E-mail must be valid' } else {return true} },
      cellRules: v => { if(v) { return (v && (v.length === 10 && /^[0-9]/.test(v))) || '10 digit cell phone format' } else {return true}},
      usernameRules: v => { return v &&  (   (v.length === 10 && /^[0-9]/.test(v))  || /.+@.+\..+/.test(v) ) || 'Valid email or cell' },
      required: v => !!v || 'Required'
    },
    notifications:[],
    customer:undefined,
    products:undefined,
    plans:undefined,
    version:'...',
    newcontent:false,
    contactinfoschema: {
      cell: undefined,
      email: undefined,
      emailverified:false,
      id: undefined,
      name: undefined,
      updatedAt: undefined,
      uuid: undefined,
      nickname: undefined,
      customeid: undefined,
      status: undefined
    },
    idpool: IdPool,
    app:App,
    client:WebClient,
    pool:UserPool,
    appstate:'normal', //ie registering, etc..
    registrants:undefined,
    step:1,
    activesku:false,
    orders:undefined,
    signingin:false,
    infodialog:false,
    infotext:undefined,
    help:{
      pininfo:"Every 'participant/player' created gets a unique PIN. Its just an attempt to more easily register you, your partner, child's partner, etc... Think of us as pioneers of the sport - . " +
          "William G. Morgan, Duke Kahanamoku ... us.. yeah.. It's NOT required..",
      players:"A player,camper,athlete is just a someone you register for an event. " +
          "The ones you have used are listed below.. You can create a new one, or import one using the PIN. " +
          "This is experimental. Try it out."
    },
    sportcode:'beach'

  },
  mutations: {
    setEmail: set('email'),
    setUsername: set('username'),
    setIsReady: set('isReady'),
    setIsLoading: set('isLoading'),
    setLoggedIn: set('loggedin'),
    setPassword: set('password'),
    setUser: set('user'),
    setSnackbar: set('snackbar'),
    setAppData: set('appdata'),
    setNtfs: set('notifications'),
    setActiveEvent: set('activeevent'),
    setEvents: set('events'),
    setConfirmationCode: set('confirmationcode'),
    setCustomer: set('customer'),
    setOrders: set('orders'),
    setAppState: set('appstate'),
    setRegistrants: set('registrants'),
    setRegistrationStep: set('step'),
    setActiveSku: set('activesku'),
    setSigningIn: set('signingin'),
    setInfoDialog: set('infodialog')
  },
  actions: {
    async post (state, data) {
      let session = await store.dispatch('cognito/fetchSession');
      return new Promise((resolve, reject) => {
        let options = {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + session.accessToken.jwtToken,
            'Pool': UserPool,
            'Org': OrgKey,
            'App':App
          },
          body: JSON.stringify(data.body)
        }
        let c = {
          '400':'warning'
        }

        fetch(store.state.url + data.path, options)
            .then((response) => response.json())
            .then((response) => {
              if(response.error && response.error.code){
                store.commit('setSnackbar',{
                  type: c[response.error.statuscode],
                  msg: response.error.message,
                  timeout:5000
                })
              }
              resolve(response)
            }).catch(error=>{
          store.commit('setSnackbar',{
            type: c[error.error.statuscode],
            msg: error.error.message,
            timeout:5000
          })
          reject(error)
        })
      })
    },


    async put (state, data) {
      let session = await store.dispatch('cognito/fetchSession');
      return new Promise((resolve, reject) => {
        let options = {
          method: 'PUT',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + session.accessToken.jwtToken,
            'Pool': UserPool,
            'Org': OrgKey,
            'App':App
          },
          body: JSON.stringify(data.body)
        }
        let c = {
          '400':'warning'
        }

        fetch(store.state.url + data.path, options)
            .then((response) => response.json())
            .then((response) => {
              if(response.error && response.error.code){
                store.commit('setSnackbar',{
                  type: c[response.error.statuscode],
                  msg: response.error.message,
                  timeout:5000
                })
              }
              resolve(response)
            }).catch(error=>{
          store.commit('setSnackbar',{
            type: c[error.error.statuscode],
            msg: error.error.message,
            timeout:5000
          })
          reject(error)
        })
      })
    },


    async get (state, data) {
      let session = await store.dispatch('cognito/fetchSession');
      return new Promise((resolve, reject) => {
        let options = {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + session.accessToken.jwtToken,
            'Pool': UserPool,
            'Org': OrgKey,
            'App':App
          }
        }
        let c = {
          '400':'warning'
        }

        fetch(store.state.url + data.path, options)
            .then((response) => response.json())
            .then((response) => {
              if(response.error && response.error.code){
                store.commit('setSnackbar',{
                  type: c[response.error.statuscode],
                  msg: response.error.message,
                  timeout:5000
                })
              }
              resolve(response)
            }).catch(error=>{
                store.commit('setSnackbar', {
                  type: c[error.error.statuscode],
                  msg: error.error.message,
                  timeout: 5000
                })
          reject(error)
        })
      })
    },


    async delete (state, data) {
      let session = await store.dispatch('cognito/fetchSession');
      return new Promise((resolve, reject) => {
        let options = {
          method: 'DELETE',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + session.accessToken.jwtToken,
            'Pool': UserPool,
            'Org': OrgKey,
            'App':App
          },
          body: JSON.stringify(data.body)
        }
        let c = {
          '400':'warning'
        }

        fetch(store.state.url + data.path, options)
            .then((response) => response.json())
            .then((response) => {
              if(response.error && response.error.code){
                store.commit('setSnackbar',{
                  type: c[response.error.statuscode],
                  msg: response.error.message,
                  timeout:5000
                })
              }
              resolve(response)
            }).catch(error=>{ console.log(error)
          store.commit('setSnackbar',{
            type: c[error.error.statuscode],
            msg: error.error.message,
            timeout:5000
          })
          reject(error)
        })
      })
    },


    async fetch (state, args) {
      let session = await store.dispatch('cognito/fetchSession');
      let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + session.accessToken.jwtToken,
        'Pool': UserPool,
        'Org': OrgKey,
        'App':App
      }
      let data = args.data
      let options = {}
      return new Promise((resolve, reject) => {
        if (args.method == 'GET') {
          options = {
            method: args.method,
            headers: headers
          }
        } else {
          options = {
            method: args.method,
            headers: headers,
            body: JSON.stringify(data)
          }
        }
        let c = {
          '400':'warning'
        }
        fetch(args.url, options)
            .then((response) => response.json())
            .then((response) => {
              if(response.error && response.error.code){
                store.commit('setSnackbar',{
                  type: c[response.error.statuscode],
                  msg: response.error.message,
                  timeout:5000
                })
              }
              resolve(response)
            }).catch(error=>{
              store.commit('setSnackbar',{
                type: c[error.error.statuscode],
                msg: error.error.message,
                timeout:5000
              })
              reject(error)
        })
      })
    },


    async openFetch (state, args) {
      let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + session.accessToken.jwtToken,
        'Pool': UserPool,
        'Org': OrgKey,
        'App':App
      }
      let data = args.data
      let options = {}
      return new Promise((resolve, reject) => {
        if (args.method == 'GET') {
          options = {
            method: args.method,
            headers: headers
          }
        } else {
          options = {
            method: args.method,
            headers: headers,
            body: JSON.stringify(data)
          }
        }
        fetch(args.url, options)
            .then((response) => response.json())
            .then((response) => {
              resolve(response)
            })
      }, error => {
        reject(error)
      })
    },


    async openPost (state, data) {
      return new Promise((resolve, reject) => {
        let options = {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Pool': UserPool,
            'Org': OrgKey,
            'App':App
          },
          body: JSON.stringify(data.body)
        }


        fetch(store.state.url + data.path, options)
            .then((response) => response.json())
            .then((response) => {
              console.log(response)
              if(response.error && response.error.code){
                this.dispatch('showError',response.error)
              }
              resolve(response)
            }).catch(error=>{

          reject(error)
        })
      })
    },


    async openGet (state, data) {
      return new Promise((resolve, reject) => {
        let options = {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Pool': UserPool,
            'Org': OrgKey,
            'App':App
          }
        }
        let c = {
          '400':'warning'
        }

        fetch(store.state.url + data.path, options)
            .then((response) => response.json())
            .then((response) => {
              console.log(response)
              if(response.error && response.error.code){
                store.commit('setSnackbar',{
                  type: c[response.error.statuscode],
                  msg: response.error.message,
                  timeout:5000
                })
              }
              resolve(response)
            }).catch(error=>{
          store.commit('setSnackbar',{
            type: c[error.error.statuscode],
            msg: error.error.message,
            timeout:5000
          })
          reject(error)
        })
      })
    },


    refreshAuth(){
      store.dispatch('cognito/fetchSession')
          .finally(() => {
            store.commit('setIsReady', true)
            if (!store.getters['cognito/isLoggedIn']) return
            store.commit('setLoggedIn',true)
            // move this to somewhere else.. it will get called way too much here...
            store.dispatch('getAppData')
          })
    },


    getAppData () {
      let args = {
        url: store.state.url + 'api/auth/authrecordv2',
        method: 'GET'
      }
      store.dispatch('fetch', args)
          .then(function (response) {
            store.dispatch('putAppOrg',response)
            store.dispatch('getCustomer')
          })
          .catch(function (e) {
            console.log(e)
          })
    },


    putAppOrg (state,data) {
      let nts = []
      // if(!data.org){
      //   nts.push({code:"apporg",text:"Set up your App/Organization",icon:"fas fa-exclamation",to:"/account/organization"})
      // }
      if(data.appdata.notifications){
        Object.keys(data.appdata.invitations).forEach(function(n){
          let nt = data.appdata.notifications[n]
          nts.push({code:nt.type, text:nt.text, icon:n.logo,logo:nt.logo, to:nt.to})
        })
      }
      if(data.org){
        store.commit('setOrg',data.org)
        store.commit('setMyOrgs',Object.values(data.appdata.orgs))
        store.commit('setPermissions',data.permissions)
      }
      if(data.appdata){
        store.commit('setAppData',data.appdata)
        // store.commit('setMyOrgs',Object.values(data.appdata.orgs))
      }
      if(nts){
        store.dispatch('addNtfs',nts)
      }
    },


    signout () {
      store.dispatch('cognito/signOut');
      store.commit('setAppData',{})
      // store.commit('setContacts',false)
      // store.commit('setGroups',false)
      // store.commit('setMyOrgs', [])
      // store.commit('setOrg',undefined);
      window.location.reload()
    },


    async getCustomer() {
      //gets stripe customer data - the apps retail users, not app owner user
      let args = {
        url: store.state.url + 'api/payments/stripegeneralusers/customer',
        method: 'GET'
      }
      store.dispatch('fetch', args)
          .then(function (response) {
            console.log(response)
            if (response === null || response.error) {
              //IMPORTANT - 'false' = NO CUSTOMER RECORD THROUGH STRIPE YET.
              store.commit('setCustomer',false)
            } else {
              store.commit('setCustomer',response)
              store.dispatch('getOrders')
            }
          }).catch(e => {
            console.log(e)
            store.commit('setCustomer',false)
      })
    },


    async getProducts() {
      let em = this;
      let args = {
        url: store.state.url + 'api/payments/stripe18panels/textappyproducts',
        method: 'GET'
      }
      store.dispatch('fetch', args)
          .then(function (response) {
            if(response.length > 0){
              store.commit('setProducts',response)
              store.dispatch('getPlans')
            } else {
              store.commit('setProducts',false)
              store.commit('setPlans',false)
            }
          }).catch(function (e) {
          em.creatingcustomer = false;
        console.log(e)
      })
    },


    async getPlans() {
      let em = this;
      let args = {
        url: store.state.url + 'api/payments/stripe18panels/textappyplans',
        method: 'GET'
      }
      store.dispatch('fetch', args)
          .then(function (response) {
            let plans = response
            plans.sort((a,b)=>(a.amount<b.amount)?1:-1)
            store.commit('setPlans',plans)
          }).catch(function (e) {
        em.creatingcustomer = false;
        console.log(e)
      })
    },


    async getOrders() {
      let args = {
        url: store.state.url + 'api/payments/stripegeneralusers/orders',
        method: 'GET'
      }
      store.dispatch('fetch', args)
          .then(function (response) {
            console.log(response)
            if (response === null || response.error) {
              //IMPORTANT - 'false' = NO CUSTOMER RECORD THROUGH STRIPE YET.
              store.commit('setOrders',false)
            } else {
              store.commit('setOrders',response)
            }
          }).catch(e => {
        console.log(e)

        store.commit('setCustomer',false)
      })
    },


    async getEvents(state){
      let events = await store.dispatch('openGet',{path:'api/event/'})
      store.commit('setEvents',events)
    },


    removeNtfs(state,item){
      let n = store.state.notifications;
      if(typeof n === 'boolean') {
        return
      } else {
        n = store.state.notifications.splice(0)
      }
      if(n.length===1){
        store.commit('setNtfs',false)
      } else {
        let index = n.findIndex(f=>{return f.code === item.code})
        let data = n.splice(index,1)
        store.commit('setNtfs',data)
      }

    },

    addNtfs(state,items){
      let n = store.state.notifications;
      if(typeof n === 'boolean') {
        n = []
      } else {
        n = store.state.notifications.splice(0)
      }
      let ln = items.length;
      for(let i=0; i<ln;i++){
        n.push(items[i])
      }
      store.commit('setNtfs',n)
    },

    reLoad(){
      window.location.reload(true)
    },

    showError(state,e){
      let c = {
        '400':'warning'
      }
      store.commit('setSnackbar',{
        type: c[e.error.statuscode],
        msg: e.error.message,
        timeout:e.timeout || 5000
      })
      return;
    }

  }
})

attachCognitoModule(store, {
  userPoolId: UserPool,
  identityPoolId: IdPool,
  userPoolWebClientId: WebClient,
  region: "us-west-2"
}, 'cognito')

store.dispatch('refreshAuth')

export default store
